export const paths = {
  MAIN: '/',
  MAIN_SPECIALITY: '/main-speciality',
  ADDITIONAL: '/additional',
  CUSTOM: '/custom',
  CONTACTS: '/contacts',
  PRIVACY_POLICY: '/privacy-policy',
};
